module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_8017.81065cf7.png";